import styled from 'styled-components';

export const DatePickerContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

export const DatePickerTrigger = styled.div`
  position: relative;
  width: 300px;
  height: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-between;
  color: #535456;
  font-size: 14px;
  font-weight: 300;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, DroidSans, Helvetica Neue;
  white-space: nowrap;
  cursor: pointer;
  padding: 0px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #f4f5f7;
  border-width: 1px;
  background-color: #fafbfc;
  margin: 0px;

  &:hover,
  &:focus {
    outline: none;
    border-color: #4c9aff;
    border-width: 2px;
    background-color: #fff;
    margin: -1px;
  }
`;

DatePickerTrigger.displayName = 'DatePickerTrigger';

export const DatePickerJumptoControl = styled.img`
  height: 20px;
  width: 11px;
  cursor: pointer;
  margin: 0px 10px;
`;

DatePickerJumptoControl.displayName = 'JumpToControl';

export const DatePickerCalendarIcon = styled.img`
  height: 16px;
`;

